<template>
  <section class="use-cases-section">
    <div class="container">
      <h2 class="title">Use Cases</h2>
      <p class="subtitle">
        Designed to support both businesses and financial institutions, Credence
        enables users to reduce risk, maintain compliance, and drive growth
      </p>

      <div class="use-cases-grid">
        <!-- Row 1 -->
        <div class="use-case-item">
          <img
            alt=""
            :src="getCDNlink('assets/new-assets/Use-Case-1.webp')"
            class="img-placeholders"
          />
          <h3 class="use-case-title">Counterparty Risk Assessment</h3>
        </div>

        <div class="use-case-item">
          <img
            alt=""
            :src="getCDNlink('assets/new-assets/Use-Case-2.webp')"
            class="img-placeholders"
          />
          <h3 class="use-case-title">Supplier or Buyer Onboarding</h3>
        </div>

        <div class="use-case-item">
          <img
            alt=""
            :src="getCDNlink('assets/new-assets/Use-Case-3.webp')"
            class="img-placeholders"
          />
          <h3 class="use-case-title">Fraud Detection and Prevention</h3>
        </div>

        <div class="use-case-item">
          <img
            alt=""
            :src="getCDNlink('assets/new-assets/Use-Case-4.webp')"
            class="img-placeholders"
          />
          <h3 class="use-case-title">Business Development</h3>
        </div>

        <!-- Row 2 -->
        <div class="use-case-item">
          <img
            alt=""
            :src="getCDNlink('assets/new-assets/Use-Case-5.webp')"
            class="img-placeholders"
          />
          <h3 class="use-case-title">Documentary Credit Issuance</h3>
        </div>

        <div class="use-case-item">
          <img
            alt=""
            :src="getCDNlink('assets/new-assets/Use-Case-6.webp')"
            class="img-placeholders"
          />
          <h3 class="use-case-title">Transactional Risk Analysis</h3>
        </div>

        <div class="use-case-item">
          <img
            alt=""
            :src="getCDNlink('assets/new-assets/Use-Case-7.webp')"
            class="img-placeholders"
          />
          <h3 class="use-case-title">Find Verified Global Trade Partners</h3>
        </div>

        <div class="use-case-item">
          <img
            alt=""
            :src="getCDNlink('assets/new-assets/Use-Case-8.webp')"
            class="img-placeholders"
          />
          <h3 class="use-case-title">Business Verification</h3>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import config from "@/config";

export default {
  name: "UseCase",
  methods: {
    getCDNlink(fileKey) {
      let baseUrl = "";
      if (
        process.env.NODE_ENV === "development" ||
        process.env.NODE_ENV === "staging"
      ) {
        baseUrl = config.stagingCDN;
      } else if (process.env.NODE_ENV === "production") {
        baseUrl = config.prodCDN;
      }

      return `${baseUrl}${fileKey}`;
    },
  },
};
</script>

<style scoped>
.use-cases-section {
  padding: 5rem 1.5rem;
  width: 100%;
  position: relative;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 80px 140px;
  box-sizing: border-box;
  gap: 55px;
  text-align: center;
  font-size: 48px;
  color: #1c1c1c;
  font-family: Figtree;
}

.container {
  margin: 0;
  width: -webkit-fill-available;
}

.title {
  text-align: center;
  color: #1e3a8a;
  font-size: 48px;
  font-weight: 700;
  margin: 0 0 0.75rem;
}

.subtitle {
  text-align: center;
  color: #1c1c1c;
  font-size: 24px;
  font-style: normal;
  margin: 0 auto 3.5rem;
  font-style: normal;
}

.use-cases-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6rem;
}

.use-case-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.icon-placeholder {
  width: 100px;
  height: 100px;
  border-radius: 12px;
  background-color: #f0f7ff;
  margin-bottom: 1.25rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

/* Custom styling for each icon placeholder */
.supplier-icon {
  border-radius: 50%;
  background-color: #2a4494;
}

.fraud-icon {
  border-radius: 50%;
  background-color: #ffffff;
  border: 2px solid #046BE1;
}

.business-dev-icon {
  border-radius: 50%;
  background-color: #2a4494;
}

.documentary-icon {
  background-color: #ffffff;
  border-radius: 8px;
}

.transactional-icon {
  background-color: #046BE1;
  border-radius: 16px;
}

.partners-icon {
  border-radius: 50%;
  background-color: #f0f7ff;
}

.verification-icon {
  border-radius: 50%;
  background-color: #046BE1;
}

/* Add decorative elements to icon placeholders */
.icon-placeholder::before,
.icon-placeholder::after {
  content: "";
  position: absolute;
}

/* Counterparty Risk Assessment */
.icon-placeholder:not([class*="-icon"])::before {
  width: 40px;
  height: 40px;
  background-color: #046BE1;
  border-radius: 50%;
  bottom: 15px;
  left: 30px;
}

.icon-placeholder:not([class*="-icon"])::after {
  width: 15px;
  height: 15px;
  background-color: #C94374;
  border-radius: 50%;
  top: 25px;
  left: 25px;
}

/* Supplier icon */
.supplier-icon::before {
  width: 40px;
  height: 40px;
  background-color: #C94374;
  border-radius: 50%;
  top: 30px;
  left: 30px;
}

.supplier-icon::after {
  width: 20px;
  height: 20px;
  background-color: #fbbf24;
  border-radius: 50%;
  bottom: 20px;
  right: 30px;
}

/* Fraud icon */
.fraud-icon::before {
  width: 30px;
  height: 30px;
  background-color: #C94374;
  border-radius: 50%;
  top: 35px;
  left: 35px;
}

.fraud-icon::after {
  width: 15px;
  height: 15px;
  background-color: #2a4494;
  border-radius: 50%;
  top: 25px;
  left: 25px;
}

/* Business Dev icon */
.business-dev-icon::before {
  width: 20px;
  height: 20px;
  background-color: #C94374;
  border-radius: 50%;
  bottom: 20px;
  left: 40px;
}

.business-dev-icon::after {
  width: 15px;
  height: 15px;
  background-color: #fbbf24;
  border-radius: 50%;
  top: 25px;
  right: 30px;
}

/* Documentary Credit icon */
.documentary-icon::before {
  width: 70%;
  height: 8px;
  background-color: #046BE1;
  border-radius: 4px;
  top: 30px;
  left: 15%;
}

.img-placeholders {
  width: 100px;
  height: auto;
  margin-bottom: 20px;
}

.documentary-icon::after {
  width: 70%;
  height: 8px;
  background-color: #C94374;
  border-radius: 4px;
  bottom: 30px;
  left: 15%;
}

/* Transactional Risk icon */
.transactional-icon::before {
  width: 20px;
  height: 20px;
  background-color: #fbbf24;
  border-radius: 50%;
  bottom: 20px;
  left: 25px;
}

.transactional-icon::after {
  width: 20px;
  height: 20px;
  background-color: #C94374;
  border-radius: 50%;
  top: 20px;
  right: 25px;
}

/* Partners icon */
.partners-icon::before {
  width: 25px;
  height: 25px;
  background-color: #046BE1;
  border-radius: 50%;
  top: 35px;
  left: 35px;
}

.partners-icon::after {
  width: 20px;
  height: 20px;
  background-color: #C94374;
  border-radius: 50%;
  bottom: 25px;
  right: 30px;
}

/* Verification icon */
.verification-icon::before {
  width: 30px;
  height: 30px;
  background-color: #fbbf24;
  border-radius: 50%;
  top: 20px;
  left: 20px;
}

.verification-icon::after {
  content: "✓";
  color: white;
  font-size: 24px;
  font-weight: bold;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.use-case-title {
  font-size: 18px;
  font-weight: 600;
  color: #1c1c1c;
  margin: 0;
}

/* Responsive styles */
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .use-cases-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
  }
}

@media (max-width: 767px) {
  .use-cases-section {
    padding: 45px 40px;
  }
  .use-cases-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }

  .img-placeholders {
    height: 80px;
    width: 80px;
  }

  .title {
    font-size: 36px;
  }

  .subtitle {
    font-size: 1rem;
    margin-bottom: 2rem;
    font-style: normal;
  }
  .use-case-title {
    max-width: 100%;
    font-size: 16px;
  }
  .icon-placeholder {
    width: 80px;
    height: 80px;
  }
}

@media (max-width: 480px) {
  .use-cases-section {
    padding: 3rem 1rem;
  }

  .use-cases-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .use-case-title {
    max-width: 100%;
    font-size: 16px;
  }
  .img-placeholders {
    height: 55px;
    width: 55px;
  }

  .icon-placeholder {
    width: 90px;
    height: 90px;
  }
}
</style>
